<div class="header">
    <div class="row">
        <div class="col-6 detail-header-left">
            <h2>Dettaglio <strong>Fornitore</strong></h2>
            <div class="detail-header-actions" *ngIf="supplier.IDSupplier !== undefined">
                <a [routerLink]="['/fornitori/modifica', supplier.IDSupplier]" class="btn btn-xs btn-primary detail-action-btn"><i class="fa fa-pencil"></i><span>Modifica</span></a>
            </div>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/fornitori']">Fornitori</a></li>
                <li class="active">Dettaglio Fornitore</li>
            </ol>
        </div>
    </div>
</div>
<div *ngIf="loadError" class="row">
    <div class="col-md-10 col-12">
        <div class="detail-empty-state">{{ loadError }}</div>
    </div>
</div>
<div class="row" *ngIf="supplier.IDSupplier !== undefined">
    <div class="col-md-6 col-12">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-truck"></i>Dati <strong>Fornitore</strong></h3>
            </div>
            <div class="panel-content detail-panel">
                <div class="detail-section">
                    <div class="detail-section-title">Anagrafica</div>
                    <div class="detail-field">
                        <span class="detail-label">ID Fornitore</span>
                        <span class="detail-value">{{ supplier.IDSupplier }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Nome</span>
                        <span class="detail-value">{{ supplier.Name || '—' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Codice Fiscale</span>
                        <span class="detail-value">{{ supplier.CF || '—' }}</span>
                    </div>
                    <div class="detail-field">
                        <span class="detail-label">Email</span>
                        <span class="detail-value" *ngIf="emails.length; else noEmail">
                            <span *ngFor="let email of emails" class="supplier-email-line">{{ email }}</span>
                        </span>
                        <ng-template #noEmail><span class="detail-value">—</span></ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="supplier.IDSupplier !== undefined">
    <div class="col-md-10 col-12" style="margin-bottom: 100px;">
        <div class="panel">
            <div class="panel-header panel-controls bg-dark">
                <h3><i class="fa fa-list"></i>Pratiche <strong>Collegate</strong></h3>
            </div>
            <div class="panel-content">
                <div *ngIf="linkedRequests.length > 0; else noLinkedRequests" class="table-container table-scroll">
                    <table class="table table-hover table-supplier-requests">
                        <thead>
                        <tr>
                            <th>ID Pratica</th>
                            <th>Data Creazione</th>
                            <th>Cliente</th>
                            <th>Tipologia</th>
                            <th>Email</th>
                            <th>Stato</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let request of linkedRequests" class="linked-request-row" (click)="goToRequestDetail(request.IDRequest)">
                            <td>{{ request.IDRequest }}</td>
                            <td>{{ request.CreationDate ? (request.CreationDate | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>
                            <td>
                                <span *ngIf="customerLabel(request); else customerMissing">{{ customerLabel(request) }}</span>
                                <ng-template #customerMissing><i>Da compilare</i></ng-template>
                            </td>
                            <td>{{ request.request_type?.RequestType || '-' }}</td>
                            <td>{{ request.Email || '-' }}</td>
                            <td>
                                <span *ngIf="request.ProgressStatus < 9" style="font-size: 13px;" class="badge badge-primary">In fase di compilazione</span>
                                <span *ngIf="request.ProgressStatus === 9 && !request.CompanyParticipation && !request.PartnersParticipation" style="font-size: 13px;" class="badge badge-info">Da convalidare</span>
                                <span *ngIf="request.ProgressStatus === 9 && (request.CompanyParticipation || request.PartnersParticipation)" style="font-size: 13px;" class="badge badge-warning">Da controllare</span>
                                <span *ngIf="request.ProgressStatus === 10" style="font-size: 13px;" class="badge badge-success">Completato</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <ng-template #noLinkedRequests>
                    <div class="detail-empty-state">
                        Nessuna pratica collegata a questo fornitore.
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
